<template>
    <div class="min-h-full flex flex-col justify-center py-12 sm:px-6 lg:px-8">
        <div class="sm:mx-auto sm:w-full sm:max-w-md">
            <img class="mx-auto h-12 w-auto" src="/public/misc/logos/logo.svg"
                 alt="Workflow">
            <h2 class="mt-6 text-center text-3xl font-extrabold text-gray-900">
                Восстановить пароль
            </h2>
        </div>

        <div class="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
            <div class="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
                <div class="space-y-6">
                    <div>
                        <label for="email" class="block text-sm font-medium text-gray-700">
                            Email адрес
                        </label>
                        <div class="mt-1">
                            <input id="email" name="email" type="email" autocomplete="email" required="true"
                                   :value="email" disabled
                                   autofocus
                                   class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        </div>
                    </div>

                    <div>
                        <label for="email" class="block text-sm font-medium text-gray-700">
                            Новый пароль
                        </label>
                        <div class="mt-1">
                            <input id="email" name="email" type="password" required="true"
                                   v-model="userPassword"
                                   autofocus
                                   class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        </div>
                    </div>

                    <div>
                        <label for="email" class="block text-sm font-medium text-gray-700">
                            Подтвердите новый пароль
                        </label>
                        <div class="mt-1">
                            <input id="email" name="email" type="password" required="true"
                                   v-model="userPasswordConfirmation"
                                   autofocus
                                   class="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm">
                        </div>
                    </div>

                    <div>
                        <button type="submit"
                                @click="submitResetPassword"
                                class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">
                            Сохранить пароль
                        </button>
                    </div>
                </div>


            </div>
        </div>
    </div>
</template>
<script>
import {mapActions} from "pinia";
import {useAuth} from "@/scripts/store/auth";

export default {
    props: {
        token: {
            required: true,
            type: String
        },
        email: {
            required: true,
            type: String
        }
    },

    data() {
        return {
            userPassword: '',
            userPasswordConfirmation: '',
        }
    },

    methods: {
        ...mapActions(useAuth, ['resetPassword']),
        async submitResetPassword() {
            await this.resetPassword(
                this.email,
                this.token,
                this.userPassword,
                this.userPasswordConfirmation
            )
        }
    }
}
</script>
